import { Skeleton } from "antd";
import React from "react";

interface IProps {
    isLoading: boolean;
}

const ActivityTabTitleSkeleton: React.FC<IProps> = ({ isLoading }) =>
    isLoading ? (
        <div className="activity-title flex">
            <Skeleton.Avatar active size={40} />
            <span className="title">{<Skeleton.Input active style={{ verticalAlign: "middle" }} />}</span>
        </div>
    ) : null;

export default ActivityTabTitleSkeleton;
